import { motion } from "framer-motion";
import { CheckCircle, MessageCircle, Mail, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

type Props = {
  nome?: string;
  telefone?: string;
  mensagemWhatsapp?: string;
};

export default function SuccessScreen({ nome, telefone, mensagemWhatsapp }: Props) {
  const formatWhatsappNumber = (phone: string | undefined) => {
    const numbers = (phone || "").replace(/\D/g, '');
    return numbers.startsWith('55') ? numbers : `55${numbers}`;
  };

  const openWhatsapp = () => {
    const number = formatWhatsappNumber(telefone);
    const message = encodeURIComponent(mensagemWhatsapp || 'Olá! Acabei de me inscrever no webinar TalkToMe Partners!');
    window.open(`https://wa.me/${number}?text=${message}`, '_blank');
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="text-center py-8"
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", delay: 0.2 }}
        className="w-24 h-24 mx-auto mb-6 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center shadow-lg shadow-green-500/30"
      >
        <CheckCircle className="w-12 h-12 text-white" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <h2 className="text-3xl font-bold text-white mb-3">
          Parabéns, {nome?.split(' ')[0]}! 🎉
        </h2>
        <p className="text-white/70 text-lg mb-8 max-w-md mx-auto">
          Sua inscrição foi confirmada com sucesso! Você receberá todos os detalhes pelo WhatsApp.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="space-y-4"
      >
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 max-w-sm mx-auto">
          <div className="flex items-center gap-3 text-left">
            <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
              <MessageCircle className="w-5 h-5 text-green-400" />
            </div>
            <div>
              <p className="text-white font-medium">WhatsApp</p>
              <p className="text-white/50 text-sm">Entre na comunidade oficial</p>
            </div>
          </div>
        </div>

        <p className="text-white/50 text-sm flex items-center justify-center gap-2">
          <Sparkles className="w-4 h-4 text-yellow-400" />
          Nos vemos no treinamento!
        </p>
      </motion.div>
    </motion.div>
  );
}
